/* Layout shell for the three legal pages. Takes a `title` and `html`
 * (already parsed from markdown by the route module) and renders them
 * inside the GJ rail with header clearance.
 *
 * `dangerouslySetInnerHTML` is safe here, the HTML is produced by
 * `marked` from markdown files we author and ship in the bundle. There
 * is no path for user input to reach this component. */
export function LegalPage({title, html, updatedOn}: {title: string; html: string; updatedOn?: string}) {
    return (
        <section className="gj-px-screen-edge-constrained pt-[calc(var(--gj-header-height)+3rem)] pb-lg2 min-h-screen">
            <div className="w-full max-w-[48rem] mx-auto">
                <h1 className="text-heading2-25 text-text-primary tracking-tight">{title}</h1>
                {updatedOn != null && updatedOn.length > 0 ? <p className="text-medium text-text-secondary mt-sm2">Last updated: {updatedOn}</p> : null}
                <div
                    className="markdown-content mt-lg"
                    dangerouslySetInnerHTML={{__html: html}}
                />
            </div>
        </section>
    );
}
